module.exports = __webpack_public_path__ + "img/envelope.86208fea.svg";